import styled from 'styled-components';
import DropDown from '@/trio-ui/Dropdown';

export const CustomDropdown = styled(DropDown)`
  .dropdown-button {
    min-width: 200px;
  }
`;

export const SalaryInput = styled.div`
  width: 216px;
`;

export const SpecialField = styled.div<{ expanded?: boolean }>`
  display: flex;
  align-items: center;
  flex: ${(props) => (props.expanded ? 1 : 'initial')};
  margin-top: ${(props) => (props.expanded ? '-7px' : '0')};
`;

export const SpecialFieldsArea = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 25px;
  margin-top: -12px;
`;

export const SpecialFieldLabel = styled.p<{ smallerMargin?: boolean }>`
  color: #6f7175;
  margin-right: ${(props) => (props.smallerMargin ? '12px' : '24px')};
  font-size: 14px;
  line-height: 21px;
`;
